import { createContext, useContext } from 'react'

interface TemplateEditorContextValue {
  canSave: boolean
  isSaving: boolean
  hasName: boolean
  onNameAndSave: () => void
}

export const TemplateEditorContext = createContext<TemplateEditorContextValue>({
  canSave: false,
  isSaving: false,
  hasName: false,
  onNameAndSave: () => {},
})

export const useTemplateEditorContext = () => useContext(TemplateEditorContext)
